<template>
  <div class="image-slider-component">
    <b-carousel id="carousel-fade" style="text-shadow: 0px 0px 2px #000;" fade indicators img-width="100%" img-height="200">
      <b-carousel-slide v-for="(image, index) in images" :key="index"  :img-src="image"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    images: Array
  }
};
</script>
